import { Button, ButtonProps } from '../Button';

interface PaginationButtonProps extends ButtonProps {
  children?: React.ReactNode;
}
const PaginationButton: React.FC<PaginationButtonProps> = ({
  className = '',
  ...props
}) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      className={`"rounded-[6px] border-borderGray border-[1px] bg-white-100 [box-shadow:0px_1px_2px_0px_rgba(0,_0,_0,_0.05)] cursor-pointer" ${className}`}
      {...props}
    >
      {props.children}
    </Button>
  );
};

export default PaginationButton;
